(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["holiday-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('holiday-coupon')) {
    customElements.define('holiday-coupon', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-copy-label]');
        this.status = this.querySelector('[role="status"]');
        this.initialLabel = this.label.textContent;
        this.copyHandler = this.copyCode.bind(this);
        this.button.addEventListener('click', this.copyHandler);
      }

      disconnectedCallback() {
        this.button.removeEventListener('click', this.copyHandler);
        clearTimeout(this.resetTimer);
      }

      async copyCode() {
        if (this.copying) return;
        this.copying = true;
        clearTimeout(this.resetTimer);

        try {
          try {
            await navigator.clipboard.writeText(this.dataset.code);
          } catch {
            this.copyWithSelection();
          }

          if (!this.isConnected) return;
          this.label.textContent = this.dataset.copied;
          this.status.classList.add('visually-hidden');
          this.status.textContent = this.dataset.copied;
          this.resetTimer = setTimeout(() => {
            this.label.textContent = this.initialLabel;
            this.status.textContent = '';
          }, 3000);
        } catch {
          this.label.textContent = this.initialLabel;
          this.status.classList.remove('visually-hidden');
          this.status.textContent = this.dataset.copyError;
        } finally {
          this.copying = false;
        }
      }

      copyWithSelection() {
        const previousFocus = document.activeElement;
        const field = document.createElement('textarea');
        field.value = this.dataset.code;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);

        try {
          field.select();
          if (!document.execCommand('copy')) throw new Error('Copy failed');
        } finally {
          field.remove();
          previousFocus?.focus({ preventScroll: true });
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
